import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
    data: [],
};

export const fetchBlogs = createAsyncThunk(
    'masters/fetchBlogs',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/blogs`);
            return { success: true, message: "Blogs fetched successfully!", data: response?.data?.blogs };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const createBlog = createAsyncThunk(
    'masters/createBlog',
    async (data) => {
        try {
            const response = await myAxios.post(`/masters/blogs`, data?.formData);

            return { success: true, message: "Blog added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updateBlog = createAsyncThunk(
    'masters/updateBlog',
    async (data) => {
        try {
            const response = await myAxios.put(`/masters/blogs/${data?.query?.blogId}`, data?.formData);

            return { success: true, message: "Blog updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteBlog = createAsyncThunk(
    'masters/deleteBlog',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/blogs/${query.blogId}`);

            return { success: true, message: "Blog deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const blogsSlice = createSlice({
    name: 'blogs',
    initialState,
    reducers: {
        clearBlogsData: state => {
            state.data = [];
        },
        setBlogsData: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const blogsReducer = blogsSlice.reducer;
export const { clearBlogsData, setBlogsData } = blogsSlice.actions;

export const selectBlogsData = (state) => state.blogs.data;
